import { stateType } from "../../state";

export function LogOut({ state }: stateType) {
  return <div>LogOut</div>;
}
